import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ITabs} from 'components/ui/LineTabsChart'

export interface ISearch {
  id?: string;
  name: string;
  email: string;
}
export interface IActivityFeed {
  name: string
  link: string
  linkUrl: string
  message: string
  codes?: Array<string>
}
export interface ITopList {
  name: string
  imageUrl?: string
  message: string
  linkUrl: string
}
interface IDashboardStore {
  chartTabActive: string
  chartTabs: Array<ITabs>
  chartLabels: Array<string>
  chartValues: Array<number>
  activityFeed: Array<IActivityFeed>
  topAffiliates: Array<ITopList>
  searchData: Array<ISearch>
  searchText: string
  selectedResult: string
  isLinkedBank: boolean
  tierFormAction: string
  settingTab: number
  isAbleMenu: boolean
  hasHandle: boolean
}

const initialState: IDashboardStore = {
  chartTabActive: 'total-sales',
  chartTabs: [],
  chartLabels: [
    'Jan 6',
    'Jan 7',
    'Jan 8',
    'Jan 9',
    'Jan 10',
    'Jan 11',
    'Jan 12',
    'Jan 13'
  ],
  chartValues: [200, 220, 250, 200, 129, 391, 229, 200],
  activityFeed: [
    {
      name: 'Claire Jones',
      message: 'referred purchase',
      link: '#F3692',
      linkUrl: '/link/'
    },
    {
      name: 'Macy Kay',
      message: 'referred purchase',
      link: '#F3691',
      linkUrl: '/link/'
    },
    {
      name: 'Jane King',
      message: 'referred purchase',
      link: '#F3684',
      linkUrl: '/link/'
    },
    {
      name: 'Carey Danes',
      message: 'referred purchase',
      link: '#F3682',
      linkUrl: '/link/'
    },
    {
      name: 'Laura Noll',
      message: 'referred purchase',
      link: '#F3679',
      linkUrl: '/link/',
      codes: ['KAYLA20']
    }
  ],
  topAffiliates: [
    {
      name: 'Phoenix Baker',
      imageUrl: '/images/placeholder/image1.png',
      message: '$753.00',
      linkUrl: '/merchant/affiliates/1'
    },
    {
      name: 'Lana Steiner',
      imageUrl: '/images/placeholder/image2.png',
      message: '$718.99',
      linkUrl: '/merchant/affiliates/1'
    },
    {
      name: 'Demi Wilkinson',
      imageUrl: '/images/placeholder/image3.png',
      message: '$520.04',
      linkUrl: '/merchant/affiliates/1'
    },
    {
      name: 'Candice Wu',
      imageUrl: '/images/placeholder/image4.png',
      message: '$295.00',
      linkUrl: '/merchant/affiliates/1'
    },
    {
      name: 'Natali Craig',
      imageUrl: '/images/placeholder/image5.png',
      message: '$280.00',
      linkUrl: '/merchant/affiliates/1'
    }
  ],
  searchData: [
    { name: 'Phoenix Baker', email: 'phoenix@gmail.com' },
    { name: 'Olivia Baker', email: 'olivia@gmail.com' },
    { name: 'Lana Baker', email: 'lana@gmail.com' },
    { name: 'Demi Baker', email: 'demi@gmail.com' },
    { name: 'Candice Baker', email: 'candice@gmail.com' },
    { name: 'Natali Baker', email: 'natali@gmail.com' },
    { name: 'Phoeaws', email: 'phoe@gmail.com' }
  ],
  searchText: '',
  selectedResult: '',
  isLinkedBank: false,
  settingTab: 0,
  tierFormAction: 'null',
  isAbleMenu: JSON.parse(localStorage.getItem('isAbleMenu') as any),
  hasHandle: true
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setChartTabActive: (state, action: PayloadAction<string>) => {
      state.chartTabActive = action.payload
    },
    setChartTabs: (state, action: PayloadAction<Array<ITabs>>) => {
      state.chartTabs = action.payload
    },
    setChartLabels: (state, action: PayloadAction<Array<string>>) => {
      state.chartLabels = action.payload
    },
    setChartValues: (state, action: PayloadAction<Array<number>>) => {
      state.chartValues = action.payload
    },
    setActivityFeed: (state, action: PayloadAction<Array<IActivityFeed>>) => {
      state.activityFeed = action.payload
    },
    setTopAffiliates: (state, action: PayloadAction<Array<ITopList>>) => {
      state.topAffiliates = action.payload
    },
    setSearchData: (state, action: PayloadAction<Array<ISearch>>) => {
      state.searchData = action.payload
    },
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload
    },
    setSelectedResult: (state, action: PayloadAction<string>) => {
      state.selectedResult = action.payload
      state.searchText = action.payload
    },
    setIsLinkedBank: (state, action: PayloadAction<boolean>) => {
      state.isLinkedBank = action.payload
    },
    setSettingTab: (state, action: PayloadAction<number>) => {
      state.settingTab = action.payload
    },
    setTierFormAction: (state, action: PayloadAction<string>) => {
      state.tierFormAction = action.payload
    },
    setIsAbleMenu: (state, action: PayloadAction<any>) => {
      state.isAbleMenu = action.payload
      localStorage.setItem('isAbleMenu', JSON.stringify(action.payload))
    },
    setHasHandle: (state, action: PayloadAction<any>) => {
      state.hasHandle = action.payload
    }
  }
})

export const {
  setChartTabActive,
  setChartTabs,
  setChartLabels,
  setChartValues,
  setActivityFeed,
  setTopAffiliates,
  setSearchData,
  setSearchText,
  setSelectedResult,
  setIsLinkedBank,
  setTierFormAction,
  setSettingTab,
  setIsAbleMenu,
  setHasHandle
} = dashboardSlice.actions

export default dashboardSlice.reducer
